import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const RobloxProfile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState(null);

  useEffect(() => {
    // Real Roblox profile data with direct link
    const realProfileData = {
      username: 'Rex123456724',
      displayName: 'Dandre',
      description: '',
      joinDate: '24/11/2019',
      friends: 98,
      following: 23,
      followers: 10,
      profileUrl: 'https://www.roblox.com/users/1332092262/profile',
      avatar: '/avatar.png',
      badges: [
        { name: 'Veteran', description: 'Been playing for years!' },
        { name: 'Friendship', description: 'Great with friends' }
      ],
      favoriteGames: [
        '[🐥] Foxy from FNAF Doom',
        'Five Nights At Freddy\'s Doom',
        '[💢] Grow a Garden 🌶️',
        '☠️ Jailbreak',
        '[COMBAT 🪓] The RakOOF'
      ],
      stats: {
        hoursPlayed: 1580,
        robuxSpent: 2450
      }
    };

    // Set profile data with a slight delay to simulate loading
    setTimeout(() => {
      setProfileData(realProfileData);
      setLoading(false);
    }, 1500);
  }, []);

  if (loading) {
    return (
      <div className="page-container">
        <motion.div 
          className="card"
          style={{ textAlign: 'center' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <h2>Loading Dandre's Roblox Profile...</h2>
          <motion.div
            style={{ 
              width: '50px', 
              height: '50px', 
              border: '3px solid #333',
              borderTop: '3px solid #fff',
              borderRadius: '50%',
              margin: '2rem auto'
            }}
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          />
        </motion.div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="card">
          <h2>Error Loading Profile</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <motion.div 
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="hero" style={{ padding: '2rem 0' }}>
          <h1>🎮 Roblox Profile</h1>
          <p>Meet {profileData.displayName} - The Gaming Legend</p>
        </div>

        <div className="grid">
          <motion.div 
            className="card"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ textAlign: 'center' }}
          >
            <img 
                src="/avatar.png" 
                alt="Dandre's Avatar" 
                className="avatar"
                style={{ 
                  marginBottom: '1rem',
                  width: '150px', 
                  height: '150px', 
                  borderRadius: '10px',
                  border: '2px solid #00D4FF'
                }}
              />
            <h2>@{profileData.username}</h2>
            <h3 style={{ color: '#ccc', marginBottom: '1rem' }}>{profileData.displayName}</h3>
            <p>{profileData.description}</p>
            <p style={{ color: '#888', marginTop: '1rem' }}>Joined: {profileData.joinDate}</p>
            <a 
              href={profileData.profileUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn"
              style={{ marginTop: '1rem', display: 'inline-block' }}
            >
              View Real Roblox Profile
            </a>
          </motion.div>

          <motion.div 
            className="card"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <h2>📊 Profile Stats</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginTop: '1rem' }}>
              <div style={{ textAlign: 'center', padding: '1rem', background: '#222', borderRadius: '8px' }}>
                <h3 style={{ color: '#fff', fontSize: '2rem' }}>{profileData.friends}</h3>
                <p style={{ color: '#ccc' }}>Friends</p>
              </div>
              <div style={{ textAlign: 'center', padding: '1rem', background: '#222', borderRadius: '8px' }}>
                <h3 style={{ color: '#fff', fontSize: '2rem' }}>{profileData.followers}</h3>
                <p style={{ color: '#ccc' }}>Followers</p>
              </div>
              <div style={{ textAlign: 'center', padding: '1rem', background: '#222', borderRadius: '8px' }}>
                <h3 style={{ color: '#fff', fontSize: '2rem' }}>{profileData.following}</h3>
                <p style={{ color: '#ccc' }}>Following</p>
              </div>

            </div>
          </motion.div>
        </div>

        <motion.div 
          className="card"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h2>🏆 Achievements & Badges</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
            {profileData.badges.map((badge, index) => (
              <motion.div 
                key={index}
                style={{ 
                  background: '#222', 
                  padding: '1rem', 
                  borderRadius: '8px', 
                  textAlign: 'center',
                  border: '1px solid #444'
                }}
                whileHover={{ scale: 1.05, borderColor: '#666' }}
                transition={{ duration: 0.2 }}
              >
                <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>{badge.name}</h3>
                <p style={{ color: '#ccc', fontSize: '0.9rem' }}>{badge.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div 
          className="card"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h2>🎯 Favorite Games</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '1rem' }}>
            {profileData.favoriteGames.map((game, index) => (
              <motion.span 
                key={index}
                style={{ 
                  background: '#333', 
                  padding: '0.5rem 1rem', 
                  borderRadius: '20px', 
                  color: '#fff',
                  border: '1px solid #555'
                }}
                whileHover={{ background: '#444', scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                {game}
              </motion.span>
            ))}
          </div>
        </motion.div>


      </motion.div>
    </div>
  );
};

export default RobloxProfile;